(function () {

  // ----------------------------
  // 1) Tap anywhere on product media -> open lightbox
  // ----------------------------
  let sx = 0, sy = 0, down = false;

  document.addEventListener("pointerdown", (e) => {
    down = true;
    sx = e.clientX;
    sy = e.clientY;
  }, { passive: true });

  document.addEventListener("pointerup", (e) => {
    if (!down) return;
    down = false;

    // Prevent opening if user swiped
    if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) return;

    const el = e.target;

    // Ignore UI controls
    if (el.closest("a,button,input,select,textarea,summary,video,model-viewer")) return;

    const mediaItem = el.closest(".product__media-item, .product__media, [data-media-id]");
    if (!mediaItem) return;

    const btn = mediaItem.querySelector(".media-lightbox-button, [is='media-lightbox-button'], .icon-zoom");
    if (btn) btn.click();

  }, { passive: true });


  // ----------------------------
  // 2) Close PhotoSwipe when tapping outside image
  // ----------------------------
  document.addEventListener("click", function (e) {

    const pswp = document.querySelector(".pswp");
    if (!pswp || !pswp.classList.contains("pswp--open")) return;

    // If clicking on image area or controls → do nothing
    if (e.target.closest(".pswp__zoom-wrap, .pswp__img, .pswp__button, .pswp__top-bar")) {
      return;
    }

    // If clicking on overlay/background → close
    if (e.target.closest(".pswp__scroll-wrap, .pswp__container, .pswp__bg")) {
      const closeBtn = pswp.querySelector(".pswp__button--close");
      if (closeBtn) closeBtn.click();
    }

  }, true);

})();